import { List, ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { facilityOffersBarPark } from '../../utils/barPark'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const SettingsNavLinks = (props) => {
	const { selectedFacility } = props
	const classes = useStyles()

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/settings/services/availability`}>
				<ListItemText primary="Services Availability" />
			</ListItem>
			
			{facilityOffersBarPark(selectedFacility) ? (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/settings/barPark/checkIn`}>
					<ListItemText primary="Bar & Park Settings" />
				</ListItem>
			) : null}
		</List>
	)
}

export default SettingsNavLinks
